(function () {
  'use strict';

  if (window.location.pathname !== '/secure/user/profile.html') {
    return
  }

  const user = JSON.parse(localStorage.getItem("user"))
  const token = localStorage.getItem("token")
  
  console.log('🔍 Profile page loaded:', {
    hasUser: !!user,
    hasToken: !!token,
    userKeys: user ? Object.keys(user) : null
  })
  
  let originalValues = {}
  let pendingIdentityMfa = { mfaChallengeToken: null }
  let currentIdentityTwoFactor = false

  function accountRoleLabel (role) {
    const m = { MEMBER: 'Mitglied', LIFE_PARTNER: 'Lebenspartner', REPRESENTATIVE: 'Vertreter' }
    return m[role] || role || '—'
  }

  function escapeHtml (s) {
    if (s == null || s === '') return ''
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
  }

  function formatPersonDisplayName (firstName, lastName) {
    const fn = (firstName || '').toString().trim()
    const ln = (lastName || '').toString().trim()
    return (fn + ' ' + ln).trim()
  }

  /** Anzeigename Vertretung aus Attributen (OpenAPI kann später eigene Felder liefern). */
  function representativePersonDisplayName (attrs) {
    if (!attrs || typeof attrs !== 'object') return ''
    const pairs = [
      [attrs.firstNameRepresentative, attrs.lastNameRepresentative],
      [attrs.representativeFirstName, attrs.representativeLastName],
      [attrs.firstNameLegalRepresentative, attrs.lastNameLegalRepresentative]
    ]
    for (let i = 0; i < pairs.length; i++) {
      const label = formatPersonDisplayName(pairs[i][0], pairs[i][1])
      if (label) return label
    }
    const single = (attrs.representativeFullName || attrs.nameRepresentative || '').toString().trim()
    return single || ''
  }

  function getCurrentMemberAttributes () {
    try {
      const u = JSON.parse(localStorage.getItem('user') || '{}')
      if (u && u.user && u.user.attributes) return u.user.attributes
    } catch (e) {}
    return {}
  }

  /** Dropdown „Zusätzliches Konto“: Personen aus Stammdaten; Rolle = option value (LIFE_PARTNER | REPRESENTATIVE). */
  function refreshSecondaryAccountPersonSelect () {
    const attrs = getCurrentMemberAttributes()
    const $sel = $('#createAccountPerson')
    const $hint = $('#createSecondaryAccountPersonHint')
    const previousVal = $sel.val()
    $sel.empty()
    $sel.append($('<option></option>').val('').text('Bitte wählen …'))

    const partnership = attrs.partnership
    const lpName = formatPersonDisplayName(attrs.firstNameLifePartner, attrs.lastNameLifePartner)
    if ((partnership === 'SPOUSES' || partnership === 'REGISTERED_CIVIL_PARTNERSHIP') && lpName) {
      $sel.append(
        $('<option></option>')
          .val('LIFE_PARTNER')
          .text(lpName + ' (Lebenspartner)')
      )
    }

    const repName =
      formatPersonDisplayName(attrs.firstNameRepresentative, attrs.lastNameRepresentative) ||
      representativePersonDisplayName(attrs)
    if (repName) {
      $sel.append(
        $('<option></option>')
          .val('REPRESENTATIVE')
          .text(repName + ' (Vertreter)')
      )
    }

    const hasPersonChoice = $sel.find('option').length > 1
    if ($hint.length) {
      if (hasPersonChoice) {
        $hint.addClass('d-none')
      } else {
        $hint.removeClass('d-none')
      }
    }
    $sel.prop('disabled', !hasPersonChoice)
    $('#btnCreateSecondaryAccount').prop('disabled', !hasPersonChoice)
    if (previousVal === 'LIFE_PARTNER' || previousVal === 'REPRESENTATIVE') {
      $sel.val(previousVal)
    }
    if (!$sel.val()) {
      $sel.val('')
    }
  }

  function getCurrentAccountType () {
    try {
      const u = JSON.parse(localStorage.getItem('user') || '{}')
      return u.accountType || 'MEMBER'
    } catch (e) {
      return 'MEMBER'
    }
  }

  function updateMfaToggleLabels () {
    $('.btn-identity-mfa-toggle').each(function () {
      const $t = $(this)
      const label = $t.is(':checked') ? 'Aktiv' : 'Inaktiv'
      $t.siblings('label').text(label)
    })
  }

  function renderAccountsTable (rows, identityPayload) {
    const accountType = getCurrentAccountType()
    let isTwoFactorEnabled = false
    if (identityPayload && identityPayload.data && identityPayload.data.attributes) {
      isTwoFactorEnabled = identityPayload.data.attributes.isTwoFactorEnabled === true
    }
    currentIdentityTwoFactor = isTwoFactorEnabled

    let html = '<table class="table table-bordered table-striped align-middle"><thead><tr><th>Rolle</th><th>E-Mail (Kennung)</th><th>Zwei-Faktor-Auth.</th><th>Aktion</th></tr></thead><tbody>'
    rows.forEach(function (row) {
      const id = row.id || ''
      const attr = row.attributes || {}
      const role = attr.userRole || ''
      const email = (attr.accountIdentifier || '').toString()
      const canDeactivate = role === 'LIFE_PARTNER' || role === 'REPRESENTATIVE'
      const isCurrentAccount = role === accountType

      html += '<tr><td>' + escapeHtml(accountRoleLabel(role)) + '</td><td>' + escapeHtml(email) + '</td><td>'
      if (isCurrentAccount) {
        html += '<div class="form-check form-switch mb-0">'
        html += '<input class="form-check-input btn-identity-mfa-toggle" type="checkbox" role="switch" id="mfaToggle-' + escapeHtml(id) + '"' + (isTwoFactorEnabled ? ' checked' : '') + '>'
        html += '<label class="form-check-label small" for="mfaToggle-' + escapeHtml(id) + '">' + (isTwoFactorEnabled ? 'Aktiv' : 'Inaktiv') + '</label>'
        html += '</div>'
      } else {
        html += '<span class="text-muted small">Nur mit diesem Konto verwaltbar</span>'
      }
      html += '</td><td>'
      if (canDeactivate && id) {
        html += '<button type="button" class="btn btn-sm btn-outline-danger btn-account-deactivate" data-account-id="' + escapeHtml(id) + '" data-role="' + escapeHtml(accountRoleLabel(role)) + '">Deaktivieren</button>'
      } else {
        html += '<span class="text-muted small">—</span>'
      }
      html += '</td></tr>'
    })
    html += '</tbody></table>'
    $('#accountsTableContainer').html(html)
  }

  function patchMyIdentity (enabled, $toggle) {
    if ($toggle) {
      $toggle.prop('disabled', true)
    }
    $.ajax({
      method: 'PATCH',
      url: '/cockpit/my-identity',
      contentType: 'application/json',
      data: JSON.stringify({
        data: {
          type: 'identities',
          attributes: { isTwoFactorEnabled: enabled }
        }
      }),
      global: false
    }).done(function (res, _text, jqXHR) {
      if (enabled && jqXHR.status === 202 && res && res.data && res.data.mfaChallengeToken) {
        pendingIdentityMfa.mfaChallengeToken = res.data.mfaChallengeToken
        $('#mfaActivationPin').val('')
        $('#mfaActivationError').addClass('d-none').empty()
        const modalEl = document.getElementById('mfaActivationModal')
        if (modalEl && typeof bootstrap !== 'undefined' && bootstrap.Modal) {
          bootstrap.Modal.getOrCreateInstance(modalEl).show()
        }
        if ($toggle) {
          $toggle.prop('checked', false)
        }
        return
      }
      if (!enabled && (jqXHR.status === 202 || (res && res.success))) {
        currentIdentityTwoFactor = false
        makeAlertBox(0, 5000, '<span class="fa fa-check"></span> Zwei-Faktor-Authentifizierung wurde deaktiviert.', '#profileAlert')
        loadMyAccounts()
        return
      }
      const msg = (res && res.error) ? res.error : 'Einstellung konnte nicht geändert werden.'
      makeAlertBox(3, 6000, '<span class="fa fa-exclamation-circle"></span> ' + msg, '#profileAlert')
      if ($toggle) {
        $toggle.prop('checked', currentIdentityTwoFactor)
      }
    }).fail(function (err) {
      if (typeof handleAuthError === 'function' && handleAuthError(err, true, '#profileAlert')) {
        if ($toggle) {
          $toggle.prop('checked', currentIdentityTwoFactor)
        }
        return
      }
      const msg = err.responseJSON && err.responseJSON.error ? err.responseJSON.error : 'Einstellung konnte nicht geändert werden.'
      makeAlertBox(3, 6000, '<span class="fa fa-exclamation-circle"></span> ' + msg, '#profileAlert')
      if ($toggle) {
        $toggle.prop('checked', currentIdentityTwoFactor)
      }
    }).always(function () {
      if ($toggle) {
        $toggle.prop('disabled', false)
      }
    })
  }

  function loadMyAccounts () {
    $('#accountsLoading').show()
    $('#accountsTableContainer').empty()

    const accountsReq = $.ajax({
      url: '/cockpit/my-accounts',
      method: 'GET',
      global: false
    })
    const identityReq = $.ajax({
      url: '/cockpit/my-identity',
      method: 'GET',
      global: false
    })

    $.when(accountsReq, identityReq).done(function (accountsRes, identityRes) {
      $('#accountsLoading').hide()
      const res = accountsRes[0]
      const identityBody = identityRes[0]

      if (!res || res.success === false) {
        const msg = (res && res.error) ? res.error : 'Konten konnten nicht geladen werden.'
        const isSession = res && res.code === 'EXTERNAL_SESSION'
        const isForbidden = res && res.code === 'EXTERNAL_FORBIDDEN'
        const level = isSession || isForbidden ? 2 : 3
        const icon = isSession || isForbidden ? 'fa-exclamation-triangle' : 'fa-exclamation-circle'
        makeAlertBox(level, 8000, '<span class="fa ' + icon + '"></span> ' + msg, '#profileAlert')
        return
      }

      const payload = res.data
      let rows = []
      if (payload && Array.isArray(payload.data)) {
        rows = payload.data
      } else if (payload && payload.data) {
        rows = [payload.data]
      }
      if (rows.length === 0) {
        $('#accountsTableContainer').html('<p class="text-muted">Keine Konten gefunden.</p>')
        return
      }

      let identityData = null
      if (identityBody && identityBody.success && identityBody.data) {
        identityData = identityBody.data
      }
      renderAccountsTable(rows, identityData)
    }).fail(function (err) {
      $('#accountsLoading').hide()
      if (typeof handleAuthError === 'function' && handleAuthError(err, true, '#profileAlert')) {
        return
      }
      const j = err.responseJSON
      const msg = (j && j.error) ? j.error : 'Konten konnten nicht geladen werden.'
      makeAlertBox(3, 5000, '<span class="fa fa-exclamation-circle"></span> ' + msg, '#profileAlert')
    })
  }

  const IDENTIFIER_CHANGE_LOGOUT_SECONDS = 10

  function clearIdentifierChangeLogoutTimer () {
    const iv = $('#identifierChangeSuccessModal').data('logoutInterval')
    if (iv) {
      clearInterval(iv)
      $('#identifierChangeSuccessModal').removeData('logoutInterval')
    }
  }

  function performPortalLogoutToLogin () {
    clearIdentifierChangeLogoutTimer()
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    localStorage.removeItem('api')
    localStorage.removeItem('jwt')
    localStorage.removeItem('jwtToken')
    const root = typeof window.rootFolder === 'string' ? window.rootFolder : '/'
    window.location.href = root
  }

  function openIdentifierChangeSuccessModal () {
    clearIdentifierChangeLogoutTimer()
    const modalEl = document.getElementById('identifierChangeSuccessModal')
    if (!modalEl || typeof bootstrap === 'undefined' || !bootstrap.Modal) {
      makeAlertBox(
        0,
        IDENTIFIER_CHANGE_LOGOUT_SECONDS * 1000 + 2000,
        '<span class="fa fa-check"></span> Wenn die Angaben gültig sind, erhalten Sie eine E-Mail mit einem Bestätigungslink. Sie werden in ' +
          IDENTIFIER_CHANGE_LOGOUT_SECONDS +
          ' Sekunden abgemeldet.',
        '#profileAlert'
      )
      setTimeout(performPortalLogoutToLogin, IDENTIFIER_CHANGE_LOGOUT_SECONDS * 1000)
      return
    }
    $('#identifierChangeLogoutSeconds').text(String(IDENTIFIER_CHANGE_LOGOUT_SECONDS))
    const modal = bootstrap.Modal.getOrCreateInstance(modalEl, { backdrop: 'static', keyboard: false })
    modal.show()
    let left = IDENTIFIER_CHANGE_LOGOUT_SECONDS
    const tick = setInterval(function () {
      left -= 1
      $('#identifierChangeLogoutSeconds').text(String(Math.max(0, left)))
      if (left <= 0) {
        clearInterval(tick)
        $('#identifierChangeSuccessModal').removeData('logoutInterval')
        performPortalLogoutToLogin()
      }
    }, 1000)
    $('#identifierChangeSuccessModal').data('logoutInterval', tick)
  }

  $(document).ready(function () {

    // Initialize Bootstrap Tabs - ensure Bootstrap is loaded
    if (typeof bootstrap !== 'undefined' && bootstrap.Tab) {
      const triggerTabList = document.querySelectorAll('#profileTabs button[data-bs-toggle="tab"]')
      triggerTabList.forEach(function(triggerEl) {
        const tabTrigger = new bootstrap.Tab(triggerEl)
        
        triggerEl.addEventListener('click', function (event) {
          event.preventDefault()
          tabTrigger.show()
        })
      })
    } else {
      // Fallback: use jQuery for tab switching if Bootstrap is not available
      $('#profileTabs button[data-bs-toggle="tab"]').on('click', function(e) {
        e.preventDefault()
        const target = $(this).data('bs-target')
        
        // Remove active class from all tabs and panes
        $('#profileTabs button').removeClass('active').attr('aria-selected', 'false')
        $('.tab-pane').removeClass('show active')
        
        // Add active class to clicked tab and corresponding pane
        $(this).addClass('active').attr('aria-selected', 'true')
        $(target).addClass('show active')
        if (target === '#account-content') {
          refreshSecondaryAccountPersonSelect()
          loadMyAccounts()
        }
      })
    }

    // Tab per URL-Hash aktivieren (z.B. profile.html#bank-content)
    if (typeof bootstrap !== 'undefined' && bootstrap.Tab) {
      const hash = window.location.hash
      if (hash === '#bank-content' && document.getElementById('bank-tab')) {
        new bootstrap.Tab(document.getElementById('bank-tab')).show()
      } else if (hash === '#partner-content' && document.getElementById('partner-tab')) {
        new bootstrap.Tab(document.getElementById('partner-tab')).show()
      } else if (hash === '#representative-content' && document.getElementById('representative-tab')) {
        if ($('#representative-tab-li').is(':visible')) {
          new bootstrap.Tab(document.getElementById('representative-tab')).show()
        }
      } else if (hash === '#account-content' && document.getElementById('account-tab')) {
        new bootstrap.Tab(document.getElementById('account-tab')).show()
        refreshSecondaryAccountPersonSelect()
        loadMyAccounts()
      }
    }

    // Load user data
    loadUserData()
    
    // Refresh user data from API to ensure we have all fields (especially bank data)
    refreshUserDataFromAPI()

    // Store original values on page load
    storeOriginalValues()
    
    // Edit button click (handles ALL edit buttons in all tabs)
    $(document).on('click', '.editProfileBtn', function() {
      enableEditing()
    })
    
    // Cancel button click (handles ALL cancel buttons in all tabs)
    $(document).on('click', '.cancelEditBtn', function() {
      cancelEditing()
    })
    
    // Save button click (handles ALL save buttons in all tabs)
    $(document).on('click', '.saveProfileBtn', function(e) {
      e.preventDefault()
      saveProfile()
    })
    
    // Partnership change - toggle life partner fields
    $(document).on('change', '#partnership', function() {
      toggleLifePartnerFields()
    })

    // SEPA Bankdaten bearbeiten (API 0.8.2)
    $(document).on('click', '.btn-edit-sepa', function() {
      if ($(this).prop('disabled')) return
      const currentUser = JSON.parse(localStorage.getItem('user') || '{}')
      const attrs = currentUser && currentUser.user && currentUser.user.attributes ? currentUser.user.attributes : {}
      $('#editSepaIban').val((attrs.sepaIban || '').replace(/\s/g, ''))
      $('#editSepaBic').val(attrs.sepaBic || '')
      $('#editSepaBankInstitution').val(attrs.sepaBankInstitution || '')
      $('#editSepaAccountHolder').val(attrs.sepaAccountHolder || '')
      $('#bankDisplayMode').hide()
      $('#bankEditMode').show()
    })

    $(document).on('click', '.btn-cancel-sepa', function() {
      $('#bankEditMode').hide()
      $('#bankDisplayMode').show()
      $('#editSepaIban, #editSepaBic, #editSepaBankInstitution, #editSepaAccountHolder').removeClass('is-invalid')
    })

    $(document).on('click', '.btn-save-sepa', function() {
      saveSepaData()
    })

    // Tab „Login & Konten“: Kontenliste laden (Bootstrap 5)
    $(document).on('shown.bs.tab', '#account-tab', function () {
      refreshSecondaryAccountPersonSelect()
      loadMyAccounts()
    })

    $(document).on('change', '.btn-identity-mfa-toggle', function () {
      const $toggle = $(this)
      const wantEnabled = $toggle.is(':checked')
      if (wantEnabled === currentIdentityTwoFactor) {
        return
      }
      if (!wantEnabled) {
        if (!window.confirm('Zwei-Faktor-Authentifizierung wirklich deaktivieren?')) {
          $toggle.prop('checked', true)
          return
        }
        patchMyIdentity(false, $toggle)
        return
      }
      patchMyIdentity(true, $toggle)
    })

    $(document).on('submit', '#mfaActivationForm', function (e) {
      e.preventDefault()
      const pin = ($('#mfaActivationPin').val() || '').trim()
      if (!pin) {
        $('#mfaActivationError').removeClass('d-none').text('Bitte geben Sie den Bestätigungscode ein.')
        return
      }
      if (!pendingIdentityMfa.mfaChallengeToken) {
        $('#mfaActivationError').removeClass('d-none').text('Keine ausstehende Aktivierung. Bitte erneut versuchen.')
        return
      }
      $('#btnMfaActivationConfirm').prop('disabled', true)
      $.ajax({
        method: 'POST',
        url: '/cockpit/my-identity/confirm',
        contentType: 'application/json',
        data: JSON.stringify({
          mfaChallengeToken: pendingIdentityMfa.mfaChallengeToken,
          pin: pin
        }),
        global: false
      }).done(function (res) {
        if (res && res.success) {
          pendingIdentityMfa.mfaChallengeToken = null
          const modalEl = document.getElementById('mfaActivationModal')
          if (modalEl && typeof bootstrap !== 'undefined' && bootstrap.Modal) {
            const inst = bootstrap.Modal.getInstance(modalEl)
            if (inst) {
              inst.hide()
            }
          }
          makeAlertBox(0, 5000, '<span class="fa fa-check"></span> Zwei-Faktor-Authentifizierung wurde aktiviert.', '#profileAlert')
          loadMyAccounts()
        } else {
          $('#mfaActivationError').removeClass('d-none').text((res && res.error) ? res.error : 'Bestätigung fehlgeschlagen.')
        }
      }).fail(function (err) {
        if (typeof handleAuthError === 'function' && handleAuthError(err, true, '#profileAlert')) {
          return
        }
        const msg = err.responseJSON && err.responseJSON.error
          ? err.responseJSON.error
          : 'Der Bestätigungscode ist ungültig oder abgelaufen.'
        $('#mfaActivationError').removeClass('d-none').text(msg)
      }).always(function () {
        $('#btnMfaActivationConfirm').prop('disabled', false)
      })
    })

    $(document).on('hidden.bs.modal', '#mfaActivationModal', function () {
      if (pendingIdentityMfa.mfaChallengeToken) {
        pendingIdentityMfa.mfaChallengeToken = null
        loadMyAccounts()
      }
      $('#mfaActivationPin').val('')
      $('#mfaActivationError').addClass('d-none').empty()
    })

    $(document).on('click', '#identifierChangeLogoutNow', function () {
      performPortalLogoutToLogin()
    })

    $(document).on('submit', '#formRequestIdentifierChange', function (e) {
      e.preventDefault()
      const email = ($('#newAccountIdentifier').val() || '').trim()
      const password = $('#identifierChangePassword').val() || ''
      if (!email || !password) {
        makeAlertBox(2, 4000, '<span class="fa fa-exclamation-triangle"></span> Bitte alle Felder ausfüllen.', '#profileAlert')
        return
      }
      let pendingLogoutAfterIdentifierChange = false
      $('#btnRequestIdentifierChange').prop('disabled', true)
      $.ajax({
        method: 'POST',
        url: '/cockpit/my-accounts/request-identifier-change',
        contentType: 'application/json',
        data: JSON.stringify({
          data: {
            type: 'accounts',
            attributes: { accountIdentifier: email, password: password }
          }
        }),
        global: false
      }).done(function (res) {
        if (res && res.success) {
          pendingLogoutAfterIdentifierChange = true
          document.getElementById('formRequestIdentifierChange').reset()
          openIdentifierChangeSuccessModal()
        } else {
          const isSession = res && res.code === 'EXTERNAL_SESSION'
          const isForbidden = res && res.code === 'EXTERNAL_FORBIDDEN'
          const level = isSession || isForbidden ? 2 : 3
          const icon = isSession || isForbidden ? 'fa-exclamation-triangle' : 'fa-exclamation-circle'
          makeAlertBox(level, 6000, '<span class="fa ' + icon + '"></span> ' + (res && res.error ? res.error : 'Anfrage fehlgeschlagen'), '#profileAlert')
        }
      }).fail(function (err) {
        if (typeof handleAuthError === 'function' && handleAuthError(err, true, '#profileAlert')) {
          return
        }
        const msg = err.responseJSON && err.responseJSON.error ? err.responseJSON.error : 'Anfrage fehlgeschlagen'
        makeAlertBox(3, 6000, '<span class="fa fa-exclamation-circle"></span> ' + msg, '#profileAlert')
      }).always(function () {
        if (!pendingLogoutAfterIdentifierChange) {
          $('#btnRequestIdentifierChange').prop('disabled', false)
        }
      })
    })

    $(document).on('submit', '#formCreateSecondaryAccount', function (e) {
      e.preventDefault()
      const userRole = ($('#createAccountPerson').val() || '').trim()
      const accountIdentifier = ($('#createAccountIdentifier').val() || '').trim()
      if (!userRole || !accountIdentifier) {
        makeAlertBox(2, 4000, '<span class="fa fa-exclamation-triangle"></span> Bitte Person und E-Mail ausfüllen.', '#profileAlert')
        return
      }
      if (userRole !== 'LIFE_PARTNER' && userRole !== 'REPRESENTATIVE') {
        makeAlertBox(2, 4000, '<span class="fa fa-exclamation-triangle"></span> Ungültige Auswahl.', '#profileAlert')
        return
      }
      $('#btnCreateSecondaryAccount').prop('disabled', true)
      $.ajax({
        method: 'POST',
        url: '/cockpit/my-accounts',
        contentType: 'application/json',
        data: JSON.stringify({
          data: {
            type: 'accounts',
            attributes: { accountIdentifier: accountIdentifier, userRole: userRole }
          }
        }),
        global: false
      }).done(function (res) {
        if (res && res.success) {
          makeAlertBox(0, 5000, '<span class="fa fa-check"></span> Konto wurde angelegt.', '#profileAlert')
          document.getElementById('formCreateSecondaryAccount').reset()
          refreshSecondaryAccountPersonSelect()
          loadMyAccounts()
        } else {
          const isSession = res && res.code === 'EXTERNAL_SESSION'
          const isForbidden = res && res.code === 'EXTERNAL_FORBIDDEN'
          const level = isSession || isForbidden ? 2 : 3
          const icon = isSession || isForbidden ? 'fa-exclamation-triangle' : 'fa-exclamation-circle'
          makeAlertBox(level, 6000, '<span class="fa ' + icon + '"></span> ' + (res && res.error ? res.error : 'Anlage fehlgeschlagen'), '#profileAlert')
        }
      }).fail(function (err) {
        if (typeof handleAuthError === 'function' && handleAuthError(err, true, '#profileAlert')) {
          return
        }
        const msg = err.responseJSON && err.responseJSON.error ? err.responseJSON.error : 'Anlage fehlgeschlagen'
        makeAlertBox(3, 6000, '<span class="fa fa-exclamation-circle"></span> ' + msg, '#profileAlert')
      }).always(function () {
        const hasChoices = $('#createAccountPerson option').length > 1
        $('#btnCreateSecondaryAccount').prop('disabled', !hasChoices)
      })
    })

    $(document).on('click', '.btn-account-deactivate', function () {
      const id = $(this).data('account-id')
      const role = $(this).data('role') || ''
      if (!id) return
      if (!window.confirm('Möchten Sie dieses Konto (' + role + ') wirklich deaktivieren?')) {
        return
      }
      const $btn = $(this).prop('disabled', true)
      $.ajax({
        method: 'PATCH',
        url: '/cockpit/my-accounts/' + encodeURIComponent(id) + '/deactivate',
        global: false
      }).done(function (res) {
        if (res && res.success !== false) {
          makeAlertBox(0, 5000, '<span class="fa fa-check"></span> Konto wurde deaktiviert.', '#profileAlert')
          loadMyAccounts()
        } else {
          makeAlertBox(3, 5000, '<span class="fa fa-exclamation-circle"></span> ' + (res && res.error ? res.error : 'Deaktivierung fehlgeschlagen'), '#profileAlert')
        }
      }).fail(function (err) {
        if (typeof handleAuthError === 'function' && handleAuthError(err, true, '#profileAlert')) {
          return
        }
        const msg = err.responseJSON && err.responseJSON.error ? err.responseJSON.error : 'Deaktivierung fehlgeschlagen'
        makeAlertBox(3, 5000, '<span class="fa fa-exclamation-circle"></span> ' + msg, '#profileAlert')
      }).always(function () {
        $btn.prop('disabled', false)
      })
    })
  })
  
  /** Vertreter-Felder aus API-Attributen (kanonische Namen + ältere Varianten). */
  function normalizedRepresentativeAttrs (attrs) {
    if (!attrs || typeof attrs !== 'object') {
      return {
        salutation: '',
        title: '',
        nobilityTitle: '',
        firstName: '',
        lastName: '',
        taxId: '',
        email: '',
        phone: '',
        mobile: ''
      }
    }
    const firstName = (
      attrs.firstNameRepresentative ||
      attrs.representativeFirstName ||
      attrs.firstNameLegalRepresentative ||
      ''
    ).toString().trim()
    const lastName = (
      attrs.lastNameRepresentative ||
      attrs.representativeLastName ||
      attrs.lastNameLegalRepresentative ||
      ''
    ).toString().trim()
    let salutation = attrs.salutationRepresentative
    if (salutation === 'Herr') salutation = 'MR'
    if (salutation === 'Frau') salutation = 'MRS'
    return {
      salutation: salutation || '',
      title: (attrs.titleRepresentative != null ? attrs.titleRepresentative : attrs.representativeTitle || '').toString(),
      nobilityTitle: (attrs.nobilityTitleRepresentative || '').toString(),
      firstName: firstName,
      lastName: lastName,
      taxId: (attrs.taxIdentificationIdRepresentative || '').toString(),
      email: (attrs.emailRepresentative != null ? attrs.emailRepresentative : attrs.representativeEmail || '').toString(),
      phone: (attrs.phoneNumberRepresentative != null ? attrs.phoneNumberRepresentative : attrs.representativePhone || '').toString(),
      mobile: (attrs.mobileRepresentative != null ? attrs.mobileRepresentative : attrs.representativeMobile || '').toString()
    }
  }

  /** True, wenn die API (inkl. Legacy-Felder) mindestens einen erkennbaren Vertreter liefert. */
  function hasRepresentativeDataFromApi (attrs) {
    if (!attrs || typeof attrs !== 'object') return false
    const full = (attrs.representativeFullName || attrs.nameRepresentative || '').toString().trim()
    if (full) return true
    if (representativePersonDisplayName(attrs)) return true
    const n = normalizedRepresentativeAttrs(attrs)
    const t = function (v) { return (v == null ? '' : String(v)).trim() }
    return !!(t(n.salutation) || t(n.title) || t(n.nobilityTitle) || t(n.firstName) || t(n.lastName) ||
      t(n.taxId) || t(n.email) || t(n.phone) || t(n.mobile))
  }

  function toggleRepresentativeTabVisibility (attrs) {
    const show = hasRepresentativeDataFromApi(attrs)
    if (show) {
      $('#representative-tab-li').show()
    } else {
      $('#representative-tab-li').hide()
      if ($('#representative-tab').hasClass('active') || $('#representative-content').hasClass('active')) {
        $('#representative-tab').removeClass('active').attr('aria-selected', 'false')
        $('#representative-content').removeClass('show active')
        $('#main-tab').addClass('active').attr('aria-selected', 'true')
        $('#main-content').addClass('show active')
      }
    }
  }

  function representativeFormHasAnyValue () {
    const ids = [
      '#salutationRepresentative',
      '#titleRepresentative',
      '#nobilityTitleRepresentative',
      '#firstNameRepresentative',
      '#lastNameRepresentative',
      '#taxIdentificationIdRepresentative',
      '#emailRepresentative',
      '#phoneNumberRepresentative',
      '#mobileRepresentative'
    ]
    for (let i = 0; i < ids.length; i++) {
      const v = ($(ids[i]).val() || '').toString().trim()
      if (v) return true
    }
    return false
  }

  // Toggle life partner fields based on partnership selection
  function toggleLifePartnerFields() {
    const partnership = $('#partnership').val()
    if (partnership === 'SPOUSES' || partnership === 'REGISTERED_CIVIL_PARTNERSHIP') {
      $('#lifePartnerFields').show()
      $('#partner-tab-li').show() // Show partner tab
      // Set required attributes when visible - only firstname and lastname are required
      $('#firstNameLifePartner, #lastNameLifePartner').prop('required', true)
      // All other fields are optional
      $('#salutationLifePartner, #titleLifePartner, #nobilityTitleLifePartner, #taxIdentificationIdLifePartner, #emailLifePartner, #phoneNumberLifePartner, #mobileLifePartner').prop('required', false)
    } else {
      $('#lifePartnerFields').hide()
      $('#partner-tab-li').hide() // Hide partner tab
      
      // Switch to main tab if partner tab is active
      if ($('#partner-tab').hasClass('active') || $('#partner-content').hasClass('active')) {
        // Remove active classes from partner tab
        $('#partner-tab').removeClass('active').attr('aria-selected', 'false')
        $('#partner-content').removeClass('show active')
        
        // Activate main tab
        $('#main-tab').addClass('active').attr('aria-selected', 'true')
        $('#main-content').addClass('show active')
      }
      
      // Remove required attributes when hidden
      $('#salutationLifePartner, #titleLifePartner, #nobilityTitleLifePartner, #firstNameLifePartner, #lastNameLifePartner, #taxIdentificationIdLifePartner, #emailLifePartner, #phoneNumberLifePartner, #mobileLifePartner').prop('required', false)
      // Clear validation classes when hidden
      $('#salutationLifePartner, #titleLifePartner, #nobilityTitleLifePartner, #firstNameLifePartner, #lastNameLifePartner, #taxIdentificationIdLifePartner, #emailLifePartner, #phoneNumberLifePartner, #mobileLifePartner').removeClass('is-invalid')
    }
    // Update original values when partnership changes
    storeOriginalValues()
  }

  // Store original form values
  function storeOriginalValues() {
    const formInputs = $('#profileForm input, #profileForm select, #partnerForm input, #partnerForm select, #representativeForm input, #representativeForm select')
    formInputs.each(function() {
      originalValues[$(this).attr('name')] = $(this).val()
    })
  }

  // Helper function to format IBAN with spaces
  function formatIBAN(iban) {
    if (!iban) return '-'
    // Remove all spaces first, then add space every 4 characters
    return iban.replace(/\s/g, '').replace(/(.{4})/g, '$1 ').trim()
  }

  // Helper function to format currency
  function formatCurrency(amount) {
    if (amount === null || amount === undefined) return '-'
    return new Intl.NumberFormat('de-DE', { 
      style: 'currency', 
      currency: 'EUR' 
    }).format(amount)
  }

  // Refresh user data from API and update localStorage
  function refreshUserDataFromAPI() {
    
    console.log('📡 Refreshing user data from API...')
    
    $.ajax({
      method: 'POST',
      url: '/cockpit/getmember',
      data: {},  // No jwtToken parameter needed - uses Authorization header
      // Prevent global error handler from triggering on this specific call
      global: false
    }).then(function(result) {
      console.log('✅ API response:', result)
      if (result.success && result.data) {
        console.log('📦 API data structure:', {
          hasData: !!result.data,
          dataType: typeof result.data,
          dataKeys: Object.keys(result.data),
          hasAttributes: !!(result.data.attributes),
          hasType: !!(result.data.type)
        })
        
        // Update localStorage mit frischen Daten (accountType/accountName beibehalten, API 0.8.2)
        const userData = {
          thumb: user ? user.thumb : null,
          user: result.data,
          accountType: user ? user.accountType : 'MEMBER',
          accountName: user ? user.accountName : ''
        }
        
        console.log('💾 Saving to localStorage:', userData)
        localStorage.setItem('user', JSON.stringify(userData))
        
        // Reload display with fresh data
        const freshUser = JSON.parse(localStorage.getItem("user"))
        console.log('🔄 Reloading display with fresh user data:', freshUser)
        if (freshUser) {
          loadUserDataFromObject(freshUser)
        }
      }
    }).catch(function(err) {
      // Handle auth errors (401/403) if handleAuthError is available
      if (typeof handleAuthError === 'function' && handleAuthError(err, false, '#profileAlert')) {
        return // Will redirect to login
      }
      // Only log non-auth errors
      console.warn('Could not refresh user data:', err)
      // Don't throw error - just continue with cached data
    })
  }

  // Load user data from localStorage or API
  function loadUserData() {
    if (user) {
      loadUserDataFromObject(user)
    }
  }
  
  // Load user data from given user object
  function loadUserDataFromObject(userObj) {
    console.log('📋 Loading user data from object:', userObj)
    
    if (!userObj || !userObj.user || !userObj.user.attributes) {
      console.warn('❌ Invalid user object structure:', {
        hasUserObj: !!userObj,
        hasUser: !!(userObj && userObj.user),
        hasAttributes: !!(userObj && userObj.user && userObj.user.attributes)
      })
      return
    }
    
    const attrs = userObj.user.attributes
    console.log('✅ User attributes:', attrs)
    
      $('#NobilityTitle').html(attrs.nobilityTitle || '')
      if (attrs.salutation === 'MR') {
        $('#Salutation').html('Herr')
      } else if (attrs.salutation === 'MRS') {
        $('#Salutation').html('Frau')
      } else {
        $('#Salutation').html('')
      }
      $('#Title').html(attrs.title || '')
      $('#firstName').html(attrs.firstName + ' ' + attrs.lastName || '')
      $('#Street').html(attrs.street || '')
      $('#Zip').html(attrs.zip + ' ' + attrs.city || '')
      $('#Country').html(attrs.country === 'DE' ? 'Deutschland' : '')
      $('#Phone').html(attrs.phoneNumber || '')
      $('#Mobile').html(attrs.mobile || '')
      $('#TaxIdentificationId').html(attrs.taxIdentificationId || '')
      $('#Email').html(attrs.email || '')
      
      // Bankverbindung & Mitgliedschaft anzeigen
      $('#displaySepaIban').html(formatIBAN(attrs.sepaIban))
      $('#displaySepaBic').html(attrs.sepaBic || '-')
      $('#displaySepaBankInstitution').html(attrs.sepaBankInstitution || '-')
      $('#displaySepaAccountHolder').html(attrs.sepaAccountHolder || '-')
      
      // SEPA-Mandat Status mit Icon
      const sepaActive = attrs.sepaMandateActive === true || attrs.sepaMandateActive === 'true'
      if (sepaActive) {
        $('#displaySepaMandateActive').html('<span class="text-success"><i class="fa fa-check-circle"></i> Aktiv</span>')
        $('.btn-edit-sepa').prop('disabled', false).removeClass('disabled')
      } else if (attrs.sepaMandateActive === false || attrs.sepaMandateActive === 'false') {
        $('#displaySepaMandateActive').html('<span class="text-danger"><i class="fa fa-times-circle"></i> Nicht aktiv</span>')
        $('.btn-edit-sepa').prop('disabled', true).addClass('disabled')
      } else {
        $('#displaySepaMandateActive').html('-')
        $('.btn-edit-sepa').prop('disabled', true).addClass('disabled')
      }
      
      // Mitgliedsbeiträge
      $('#displayMembershipFeeCurrentYear').html(formatCurrency(attrs.membershipFeeCurrentYear))
      $('#displayMembershipFeePreviousYear').html(formatCurrency(attrs.membershipFeePreviousYear))
      
      let partnershipText = ''
      if (attrs.partnership === 'SINGLE') {
        partnershipText = 'Ledig'
      } else if (attrs.partnership === 'SPOUSES') {
        partnershipText = 'Verheiratet'
      } else if (attrs.partnership === 'REGISTERED_CIVIL_PARTNERSHIP') {
        partnershipText = 'Eingetragene Lebenspartnerschaft'
      }
      $('#Partnership').html(partnershipText)

      // Load life partner data if partnership is SPOUSES or REGISTERED_CIVIL_PARTNERSHIP
      const partnership = attrs.partnership
      if (partnership === 'SPOUSES' || partnership === 'REGISTERED_CIVIL_PARTNERSHIP') {
        // Display life partner data
        if (attrs.salutationLifePartner === 'MR') {
          $('#SalutationLifePartner').html('Herr')
        } else if (attrs.salutationLifePartner === 'MRS') {
          $('#SalutationLifePartner').html('Frau')
        } else {
          $('#SalutationLifePartner').html('')
        }
        $('#TitleLifePartner').html(attrs.titleLifePartner || '')
        $('#NobilityTitleLifePartner').html(attrs.nobilityTitleLifePartner || '')
        $('#FirstNameLifePartner').html(attrs.firstNameLifePartner || '')
        $('#LastNameLifePartner').html(attrs.lastNameLifePartner || '')
        $('#TaxIdentificationIdLifePartner').html(attrs.taxIdentificationIdLifePartner || '')
        $('#EmailLifePartner').html(attrs.emailLifePartner || '')
        $('#PhoneNumberLifePartner').html(attrs.phoneNumberLifePartner || '')
        $('#MobileLifePartner').html(attrs.mobileLifePartner || '')
        
        $('#lifePartnerDisplay').show()
        
        // Populate form fields
        if (attrs.salutationLifePartner === 'MR') {
          $('#salutationLifePartner').val('MR')
        } else if (attrs.salutationLifePartner === 'MRS') {
          $('#salutationLifePartner').val('MRS')
        } else {
          $('#salutationLifePartner').val('')
        }
        $('#titleLifePartner').val(attrs.titleLifePartner || '')
        $('#nobilityTitleLifePartner').val(attrs.nobilityTitleLifePartner || '')
        $('#firstNameLifePartner').val(attrs.firstNameLifePartner || '')
        $('#lastNameLifePartner').val(attrs.lastNameLifePartner || '')
        $('#taxIdentificationIdLifePartner').val(attrs.taxIdentificationIdLifePartner || '')
        $('#emailLifePartner').val(attrs.emailLifePartner || '')
        $('#phoneNumberLifePartner').val(attrs.phoneNumberLifePartner || '')
        $('#mobileLifePartner').val(attrs.mobileLifePartner || '')
        
        $('#lifePartnerFields').show()
      } else {
        $('#lifePartnerDisplay').hide()
        $('#lifePartnerFields').hide()
      }

      const rep = normalizedRepresentativeAttrs(attrs)
      if (rep.salutation === 'MR') {
        $('#salutationRepresentative').val('MR')
      } else if (rep.salutation === 'MRS') {
        $('#salutationRepresentative').val('MRS')
      } else {
        $('#salutationRepresentative').val('')
      }
      $('#titleRepresentative').val(rep.title || '')
      $('#nobilityTitleRepresentative').val(rep.nobilityTitle || '')
      $('#firstNameRepresentative').val(rep.firstName || '')
      $('#lastNameRepresentative').val(rep.lastName || '')
      $('#taxIdentificationIdRepresentative').val(rep.taxId || '')
      $('#emailRepresentative').val(rep.email || '')
      $('#phoneNumberRepresentative').val(rep.phone || '')
      $('#mobileRepresentative').val(rep.mobile || '')

      toggleRepresentativeTabVisibility(attrs)

      $('#title').val(attrs.title || '')
      $('#nobilitytitle').val(attrs.nobilityTitle || '')
      if (attrs.salutation === 'MR') {
        $('#salutation').val('MR')
      } else if (attrs.salutation === 'MRS') {
        $('#salutation').val('MRS')
      } else {
        $('#salutation').val('')
      }
      $('#firstname').val(attrs.firstName || '')
      $('#lastname').val(attrs.lastName || '')
      $('#street').val(attrs.street || '')
      $('#zip').val(attrs.zip || '')
      $('#city').val(attrs.city || '')
      $('#country').val(attrs.country || '')
      $('#email').val(attrs.email || '')
      $('#mobile').val(attrs.mobile || '')
      $('#phone').val(attrs.phoneNumber || '')
      $('#taxIdentificationId').val(attrs.taxIdentificationId || '')
      $('#partnership').val(attrs.partnership || '')
      
      // Show/hide life partner fields and tab based on partnership
      toggleLifePartnerFields()
      
      var displayName = userObj.accountName || (attrs.firstName + ' ' + attrs.lastName) || ''
      var accountType = userObj.accountType || 'MEMBER'
      var welcomeName = displayName + '!'
      var accountTypeHintText = ''
      if (accountType === 'LIFE_PARTNER') {
        accountTypeHintText = '(als Lebenspartner angemeldet)'
      } else if (accountType === 'REPRESENTATIVE') {
        accountTypeHintText = '(als Vertreter angemeldet)'
      }
      $('#username').html(welcomeName)
      if ($('#accountTypeWelcomeHint').length && accountTypeHintText) {
        $('#accountTypeWelcomeHint').html('<small class="text-muted" style="font-size: 0.8em">' + accountTypeHintText + '</small>').show()
      } else       if ($('#accountTypeWelcomeHint').length) {
        $('#accountTypeWelcomeHint').empty().hide()
      }

      refreshSecondaryAccountPersonSelect()
  }

  // Enable editing mode
  function enableEditing() {
    // Make all input fields editable except "country"
    $('#profileForm input:not(#country)').prop('disabled', false).prop('readonly', false)
    $('#profileForm select:not(#country)').prop('disabled', false).prop('readonly', false)
    
    // Enable life partner fields in partnerForm
    $('#partnerForm input').prop('disabled', false).prop('readonly', false)
    $('#partnerForm select').prop('disabled', false).prop('readonly', false)

    $('#representativeForm input').prop('disabled', false).prop('readonly', false)
    $('#representativeForm select').prop('disabled', false).prop('readonly', false)
    
    // Hide ALL edit buttons, show ALL save and cancel buttons (in all tabs)
    $('.editProfileBtn').hide()
    $('.saveProfileBtn').show()
    $('.cancelEditBtn').show()
    
    // Add visual feedback
    $('#profileForm input:not(#country)').addClass('editable')
    $('#profileForm select:not(#country)').addClass('editable')
    $('#partnerForm input').addClass('editable')
    $('#partnerForm select').addClass('editable')
    $('#representativeForm input').addClass('editable')
    $('#representativeForm select').addClass('editable')
    
    // Toggle life partner fields visibility based on partnership
    const partnership = $('#partnership').val()
    if (partnership === 'SPOUSES' || partnership === 'REGISTERED_CIVIL_PARTNERSHIP') {
      $('#lifePartnerFields').show()
      $('#partner-tab-li').show()
    } else {
      $('#lifePartnerFields').hide()
      $('#partner-tab-li').hide()
    }
  }

  // Cancel editing and restore original values
  function cancelEditing() {
    // Restore original values
    Object.keys(originalValues).forEach(function(key) {
      $('input[name="' + key + '"], select[name="' + key + '"]').val(originalValues[key])
    })
    
    // Disable all input fields in both forms
    $('#profileForm input').prop('disabled', true).prop('readonly', true)
    $('#profileForm select').prop('disabled', true).prop('readonly', true)
    $('#partnerForm input').prop('disabled', true).prop('readonly', true)
    $('#partnerForm select').prop('disabled', true).prop('readonly', true)
    $('#representativeForm input').prop('disabled', true).prop('readonly', true)
    $('#representativeForm select').prop('disabled', true).prop('readonly', true)
    
    // Show ALL edit buttons, hide ALL save and cancel buttons (in all tabs)
    $('.editProfileBtn').show()
    $('.saveProfileBtn').hide()
    $('.cancelEditBtn').hide()
    
    // Remove visual feedback
    $('#profileForm input').removeClass('editable')
    $('#profileForm select').removeClass('editable')
    $('#partnerForm input').removeClass('editable')
    $('#partnerForm select').removeClass('editable')
    $('#representativeForm input').removeClass('editable')
    $('#representativeForm select').removeClass('editable')
    
    // Remove validation classes
    $('#profileForm input').removeClass('is-invalid')
    $('#profileForm select').removeClass('is-invalid')
    $('#partnerForm input').removeClass('is-invalid')
    $('#partnerForm select').removeClass('is-invalid')
    $('#representativeForm input').removeClass('is-invalid')
    $('#representativeForm select').removeClass('is-invalid')
    
    // Toggle life partner fields based on partnership
    toggleLifePartnerFields()

  }

  // Save profile data
  function saveProfile() {
    const formData = {
      title: $('#title').val(),
      nobilitytitle: $('#nobilitytitle').val(),
      salutation: $('#salutation').val(),
      firstname: $('#firstname').val(),
      lastname: $('#lastname').val(),
      street: $('#street').val(),
      zip: $('#zip').val(),
      city: $('#city').val(),
      country: $('#country').val(),
      email: $('#email').val(),
      phone: $('#phone').val(),
      mobile: $('#mobile').val(),
      taxIdentificationId: $('#taxIdentificationId').val(),
      partnership: $('#partnership').val(),
    }
    
    // Add life partner data if partnership is SPOUSES or REGISTERED_CIVIL_PARTNERSHIP
    const partnership = formData.partnership
    if (partnership === 'SPOUSES' || partnership === 'REGISTERED_CIVIL_PARTNERSHIP') {
      formData.salutationLifePartner = $('#salutationLifePartner').val()
      formData.titleLifePartner = $('#titleLifePartner').val()
      formData.nobilityTitleLifePartner = $('#nobilityTitleLifePartner').val()
      formData.firstNameLifePartner = $('#firstNameLifePartner').val()
      formData.lastNameLifePartner = $('#lastNameLifePartner').val()
      formData.taxIdentificationIdLifePartner = $('#taxIdentificationIdLifePartner').val()
      formData.emailLifePartner = $('#emailLifePartner').val()
      formData.phoneNumberLifePartner = $('#phoneNumberLifePartner').val()
      formData.mobileLifePartner = $('#mobileLifePartner').val()
    }

    formData.salutationRepresentative = $('#salutationRepresentative').val()
    formData.titleRepresentative = $('#titleRepresentative').val()
    formData.nobilityTitleRepresentative = $('#nobilityTitleRepresentative').val()
    formData.firstNameRepresentative = $('#firstNameRepresentative').val()
    formData.lastNameRepresentative = $('#lastNameRepresentative').val()
    formData.taxIdentificationIdRepresentative = $('#taxIdentificationIdRepresentative').val()
    formData.emailRepresentative = $('#emailRepresentative').val()
    formData.phoneNumberRepresentative = $('#phoneNumberRepresentative').val()
    formData.mobileRepresentative = $('#mobileRepresentative').val()
    
    // Validate required fields - only firstname and lastname are required
    const missingFields = []
    
    if (!formData.firstname || formData.firstname.trim() === '') {
      missingFields.push('Vorname')
      $('#firstname').addClass('is-invalid')
    } else {
      $('#firstname').removeClass('is-invalid')
    }
    
    if (!formData.lastname || formData.lastname.trim() === '') {
      missingFields.push('Nachname')
      $('#lastname').addClass('is-invalid')
    } else {
      $('#lastname').removeClass('is-invalid')
    }
    
    // Validate life partner fields if partnership requires them - only firstname and lastname are required
    if (partnership === 'SPOUSES' || partnership === 'REGISTERED_CIVIL_PARTNERSHIP') {
      if (!formData.firstNameLifePartner || formData.firstNameLifePartner.trim() === '') {
        missingFields.push('Vorname (Lebenspartner)')
        $('#firstNameLifePartner').addClass('is-invalid')
      } else {
        $('#firstNameLifePartner').removeClass('is-invalid')
      }
      
      if (!formData.lastNameLifePartner || formData.lastNameLifePartner.trim() === '') {
        missingFields.push('Nachname (Lebenspartner)')
        $('#lastNameLifePartner').addClass('is-invalid')
      } else {
        $('#lastNameLifePartner').removeClass('is-invalid')
      }
      
      // Validate optional fields - if provided, must not be empty
      if (formData.titleLifePartner && formData.titleLifePartner.trim() === '') {
        makeAlertBox(2, 3000, '<span class="fa fa-exclamation-triangle"></span> Das Titel-Feld des Lebenspartners darf nicht leer sein, wenn es ausgefüllt wird', '#profileAlert')
        $('#titleLifePartner').addClass('is-invalid')
        return
      } else {
        $('#titleLifePartner').removeClass('is-invalid')
      }
      
      if (formData.nobilityTitleLifePartner && formData.nobilityTitleLifePartner.trim() === '') {
        makeAlertBox(2, 3000, '<span class="fa fa-exclamation-triangle"></span> Das Adelstitel-Feld des Lebenspartners darf nicht leer sein, wenn es ausgefüllt wird', '#profileAlert')
        $('#nobilityTitleLifePartner').addClass('is-invalid')
        return
      } else {
        $('#nobilityTitleLifePartner').removeClass('is-invalid')
      }
    }

    const repAny = representativeFormHasAnyValue()
    if (repAny) {
      if (!formData.firstNameRepresentative || formData.firstNameRepresentative.trim() === '') {
        missingFields.push('Vorname (Vertreter)')
        $('#firstNameRepresentative').addClass('is-invalid')
      } else {
        $('#firstNameRepresentative').removeClass('is-invalid')
      }
      if (!formData.lastNameRepresentative || formData.lastNameRepresentative.trim() === '') {
        missingFields.push('Nachname (Vertreter)')
        $('#lastNameRepresentative').addClass('is-invalid')
      } else {
        $('#lastNameRepresentative').removeClass('is-invalid')
      }
      if (formData.titleRepresentative && formData.titleRepresentative.trim() === '') {
        makeAlertBox(2, 3000, '<span class="fa fa-exclamation-triangle"></span> Das Titel-Feld des Vertreters darf nicht leer sein, wenn es ausgefüllt wird', '#profileAlert')
        $('#titleRepresentative').addClass('is-invalid')
        return
      } else {
        $('#titleRepresentative').removeClass('is-invalid')
      }
      if (formData.nobilityTitleRepresentative && formData.nobilityTitleRepresentative.trim() === '') {
        makeAlertBox(2, 3000, '<span class="fa fa-exclamation-triangle"></span> Das Adelstitel-Feld des Vertreters darf nicht leer sein, wenn es ausgefüllt wird', '#profileAlert')
        $('#nobilityTitleRepresentative').addClass('is-invalid')
        return
      } else {
        $('#nobilityTitleRepresentative').removeClass('is-invalid')
      }
    } else {
      $('#salutationRepresentative, #titleRepresentative, #nobilityTitleRepresentative, #firstNameRepresentative, #lastNameRepresentative, #taxIdentificationIdRepresentative, #emailRepresentative, #phoneNumberRepresentative, #mobileRepresentative').removeClass('is-invalid')
    }
    
    // Show error if any required fields are missing
    if (missingFields.length > 0) {
      makeAlertBox(2, 3000, '<span class="fa fa-exclamation-triangle"></span> Bitte füllen Sie alle Pflichtfelder aus: ' + missingFields.join(', '), '#profileAlert')
      // Scroll to first invalid field
      $('html, body').animate({
        scrollTop: $('.is-invalid').first().offset().top - 100
      }, 500)
      return
    }

    //console.log(formData)
    //console.log(originalValues)

    // Die ursprünglichen Werte kommen aus dem Objekt originalValues,
    // das beim Laden des Profils oder beim Start des Editierens mit den aktuellen Formularwerten befüllt wird.
    // Vergleiche aktuelle und ursprüngliche Werte, falls keine Änderung, zeige Alert und breche ab
    
    let unchanged = true
    
    // Check if partnership changed
    const originalPartnership = originalValues.partnership || ''
    const currentPartnership = formData.partnership || ''
    const partnershipChanged = originalPartnership !== currentPartnership
    
    // If partnership changed, there are definitely changes
    if (partnershipChanged) {
      unchanged = false
    } else {
      // Compare all fields in formData
      for (let key in formData) {
        if (formData.hasOwnProperty(key)) {
          const currentValue = formData[key] || ''
          const originalValue = originalValues[key] || ''
          
          // Normalize values for comparison (trim whitespace)
          const normalizedCurrent = String(currentValue).trim()
          const normalizedOriginal = String(originalValue).trim()
          
          if (normalizedCurrent !== normalizedOriginal) {
            unchanged = false
            break
          }
        }
      }
      
      // Also check if any fields in originalValues are missing in formData
      // (this handles cases where partnership was removed and life partner fields should be null)
      if (unchanged) {
        for (let key in originalValues) {
          if (originalValues.hasOwnProperty(key) && !formData.hasOwnProperty(key)) {
            // If partnership is SINGLE, life partner fields should not be in formData
            if (currentPartnership === 'SINGLE' && key.includes('LifePartner')) {
              // This is expected, continue
              continue
            }
            // Otherwise, this is a change
            unchanged = false
            break
          }
        }
      }
    }
    
    if (unchanged) {
      makeAlertBox(1, 3000, '<span class="fa fa-info-circle"></span> Es wurden keine Änderungen vorgenommen', '#profileAlert')
      cancelEditing()
      return
    }

    // Show loading state
    $('.saveProfileBtn').prop('disabled', true).html('<i class="fa fa-spinner fa-spin"></i> Speichern...')
    
    // Save to API (placeholder - implement actual API call)
    saveProfileData(formData)
      .then(function(result) {
        makeAlertBox(0, 5000, '<span class="fa fa-check"></span> Profil erfolgreich gespeichert', '#profileAlert')
        
        // Update stored values
        storeOriginalValues()
        
        // Disable editing mode for both forms
        $('#profileForm input').prop('disabled', true).prop('readonly', true)
        $('#profileForm select').prop('disabled', true).prop('readonly', true)
        $('#partnerForm input').prop('disabled', true).prop('readonly', true)
        $('#partnerForm select').prop('disabled', true).prop('readonly', true)
        $('#representativeForm input').prop('disabled', true).prop('readonly', true)
        $('#representativeForm select').prop('disabled', true).prop('readonly', true)

        // Update ALL buttons (in all tabs)
        $('.editProfileBtn').show()
        $('.saveProfileBtn').hide()
        $('.cancelEditBtn').hide()

        // Remove editable styling from both forms
        $('#profileForm input').removeClass('editable')
        $('#profileForm select').removeClass('editable')
        $('#partnerForm input').removeClass('editable')
        $('#partnerForm select').removeClass('editable')
        $('#representativeForm input').removeClass('editable')
        $('#representativeForm select').removeClass('editable')
        
        // Update life partner display based on partnership
        const partnership = $('#partnership').val()
        if (partnership === 'SPOUSES' || partnership === 'REGISTERED_CIVIL_PARTNERSHIP') {
          // Update display fields
          if ($('#salutationLifePartner').val() === 'MR') {
            $('#SalutationLifePartner').html('Herr')
          } else if ($('#salutationLifePartner').val() === 'MRS') {
            $('#SalutationLifePartner').html('Frau')
          } else {
            $('#SalutationLifePartner').html('')
          }
          $('#TitleLifePartner').html($('#titleLifePartner').val() || '')
          $('#NobilityTitleLifePartner').html($('#nobilityTitleLifePartner').val() || '')
          $('#FirstNameLifePartner').html($('#firstNameLifePartner').val() || '')
          $('#LastNameLifePartner').html($('#lastNameLifePartner').val() || '')
          $('#TaxIdentificationIdLifePartner').html($('#taxIdentificationIdLifePartner').val() || '')
          $('#EmailLifePartner').html($('#emailLifePartner').val() || '')
          $('#PhoneNumberLifePartner').html($('#phoneNumberLifePartner').val() || '')
          $('#MobileLifePartner').html($('#mobileLifePartner').val() || '')
          $('#lifePartnerDisplay').show()
        } else {
          $('#lifePartnerDisplay').hide()
        }

      })
      .catch(function(err) {
        // Handle auth errors (401/403) if handleAuthError is available
        if (typeof handleAuthError === 'function' && handleAuthError(err, true, '#profileAlert')) {
          return // Will redirect to login
        }
        // Show error message for other errors
        makeAlertBox(3, 5000, '<span class="fa fa-exclamation-circle"></span> Fehler beim Speichern: ' + err.message, '#profileAlert')
      })
      .finally(function() {
        $('.saveProfileBtn').prop('disabled', false).html('<i class="fa fa-check"></i> Speichern')
      })
  }

  // IBAN validieren (Format + Mod-97-Checksumme nach ISO 13616)
  function validateIBAN(iban) {
    const cleaned = (iban || '').replace(/\s/g, '').toUpperCase()
    if (cleaned.length < 15 || cleaned.length > 34) return false
    if (!/^[A-Z]{2}[0-9]{2}[A-Z0-9]+$/.test(cleaned)) return false
    const rearranged = cleaned.slice(4) + cleaned.slice(0, 4)
    let numeric = ''
    for (let i = 0; i < rearranged.length; i++) {
      numeric += /[A-Z]/.test(rearranged[i]) ? (rearranged[i].charCodeAt(0) - 55) : rearranged[i]
    }
    let remainder = 0
    for (let i = 0; i < numeric.length; i++) {
      remainder = (remainder * 10 + parseInt(numeric[i], 10)) % 97
    }
    return remainder === 1
  }

  // SEPA-Daten speichern (API 0.8.2)
  function saveSepaData() {
    const iban = ($('#editSepaIban').val() || '').replace(/\s/g, '').trim()
    const bic = ($('#editSepaBic').val() || '').trim()
    const bankInstitution = ($('#editSepaBankInstitution').val() || '').trim()
    const accountHolder = ($('#editSepaAccountHolder').val() || '').trim()

    $('#editSepaIban, #editSepaBic, #editSepaBankInstitution, #editSepaAccountHolder').removeClass('is-invalid')

    const errors = []
    if (!iban) errors.push('IBAN')
    else if (!validateIBAN(iban)) {
      errors.push('IBAN (ungültiges Format)')
      $('#editSepaIban').addClass('is-invalid')
    }
    if (!bic) {
      errors.push('BIC')
      $('#editSepaBic').addClass('is-invalid')
    }
    if (!bankInstitution) {
      errors.push('Bankinstitut')
      $('#editSepaBankInstitution').addClass('is-invalid')
    }
    if (!accountHolder) {
      errors.push('Kontoinhaber')
      $('#editSepaAccountHolder').addClass('is-invalid')
    }

    if (errors.length > 0) {
      makeAlertBox(2, 4000, '<span class="fa fa-exclamation-triangle"></span> Bitte füllen Sie alle Pflichtfelder aus: ' + errors.join(', '), '#profileAlert')
      return
    }

    $('.btn-save-sepa').prop('disabled', true).html('<i class="fa fa-spinner fa-spin"></i> Speichern...')

    $.ajax({
      method: 'PATCH',
      url: '/cockpit/my-sepa-information',
      contentType: 'application/json',
      data: JSON.stringify({
        data: {
          type: 'members',
          attributes: { iban, bic, bankInstitution, accountHolder }
        }
      }),
      global: false,
      success: function() {
        makeAlertBox(0, 5000, '<span class="fa fa-check"></span> Bankdaten erfolgreich aktualisiert. Eine Info-Mail wurde an Ihre Beratungsstelle gesendet.', '#profileAlert')
        $('#bankEditMode').hide()
        $('#bankDisplayMode').show()
        refreshUserDataFromAPI()
      },
      error: function(err) {
        if (typeof handleAuthError === 'function' && handleAuthError(err, true, '#profileAlert')) {
          return
        }
        const msg = err.responseJSON && err.responseJSON.error ? err.responseJSON.error : (err.statusText || 'Fehler beim Speichern')
        makeAlertBox(3, 5000, '<span class="fa fa-exclamation-circle"></span> ' + msg, '#profileAlert')
      },
      complete: function() {
        $('.btn-save-sepa').prop('disabled', false).html('<i class="fa fa-check"></i> Speichern')
      }
    })
  }

  // Save profile data to API
  function saveProfileData(data) {

    console.log(data)
    return new Promise(function(resolve, reject) {
      $.ajax({
        method: 'POST',
        url: '/cockpit/changemember',
        global: false, // Prevent global error handler
        data: {
          title: data.title,
          nobilitytitle: data.nobilitytitle,
          salutation: data.salutation,
          firstname: data.firstname,
          lastname: data.lastname,
          street: data.street,
          zip: data.zip,
          city: data.city,
          country: data.country,
          email: data.email,
          phone: data.phone,
          mobile: data.mobile,
          taxIdentificationId: data.taxIdentificationId,
          partnership: data.partnership,
          salutationLifePartner: data.salutationLifePartner || null,
          titleLifePartner: data.titleLifePartner || null,
          nobilityTitleLifePartner: data.nobilityTitleLifePartner || null,
          firstNameLifePartner: data.firstNameLifePartner || null,
          lastNameLifePartner: data.lastNameLifePartner || null,
          taxIdentificationIdLifePartner: data.taxIdentificationIdLifePartner || null,
          emailLifePartner: data.emailLifePartner || null,
          phoneNumberLifePartner: data.phoneNumberLifePartner || null,
          mobileLifePartner: data.mobileLifePartner || null,
          salutationRepresentative: data.salutationRepresentative || null,
          titleRepresentative: data.titleRepresentative || null,
          nobilityTitleRepresentative: data.nobilityTitleRepresentative || null,
          firstNameRepresentative: data.firstNameRepresentative || null,
          lastNameRepresentative: data.lastNameRepresentative || null,
          taxIdentificationIdRepresentative: data.taxIdentificationIdRepresentative || null,
          emailRepresentative: data.emailRepresentative || null,
          phoneNumberRepresentative: data.phoneNumberRepresentative || null,
          mobileRepresentative: data.mobileRepresentative || null,
        },
        success: function(result) {
          if (result && result.error !== undefined) {
            reject(new Error(result.error))
            return
          }
          resolve(result)
        },
        error: function(err) {
          // Handle auth errors (401/403) - will redirect to login
          if (typeof handleAuthError === 'function' && handleAuthError(err, true, '#profileAlert')) {
            reject(new Error('Sitzung abgelaufen'))
            return
          }
          // Handle other errors
          if (err && err.status === 400) {
            reject(new Error('Ungültige Daten'))
            return
          }
          reject(new Error((err && err.statusText) || 'Ein Fehler ist aufgetreten'))
        }
      })
    })
  }

})();